import {withKnownRoute} from '../../lib/routes';
import {OriginsPage} from './origins-page';

export default withKnownRoute(OriginsPage);
